import { gql } from "@apollo/client";

export const PLAYER_STATS_QUERY = gql`
    query PlayerStatsQuery {
        playerStats {
            bits
            checkins
            clanRank
            giftedSubs
            lifetimeVp
            overallRank
            lifetimeRank
            raids
            seasonVp
            sentryTime
            shieldValue
            shieldTwoValue
            wheelOfHamingjaWins
            exalted
            reforgeTokens
            wohTokens
            totalDonated
            merchandise
            shieldMatesCount
            ravenguardPoints
            shieldTwoVp
            shieldTwoCheckins
            shieldTwoRaids
            shieldTwoSentryTime
            shieldTwoBits
            shieldTwoGiftedSubs
            shieldTwoWheelOfHamingjaWins
            shieldTwoRavenguardPoints
            shieldTwoTotalDonated
            shieldTwoMerchandise
            shieldTwoMonthsSubscribed
            shieldTwoGotaMonths
            availableFreeRunestoneClaims
        }
    }
`;

export const OTHER_PLAYER_STATS_QUERY = gql`
    query OtherPlayerStats($playerId: UUID!) {
        otherPlayerStats(playerId: $playerId) {
            bits
            checkins
            clanRank
            exalted
            reforgeTokens
            giftedSubs
            lifetimeRank
            lifetimeVp
            overallRank
            raids
            seasonVp
            sentryTime
            shieldValue
            shieldTwoValue
            wheelOfHamingjaWins
            wohTokens
            shieldMatesCount
            ravenguardPoints
            shieldTwoVp
            shieldTwoCheckins
            shieldTwoRaids
            shieldTwoSentryTime
            shieldTwoBits
            shieldTwoGiftedSubs
            shieldTwoWheelOfHamingjaWins
            shieldTwoRavenguardPoints
            shieldTwoTotalDonated
            shieldTwoMerchandise
            shieldTwoMonthsSubscribed
            shieldTwoGotaMonths
        }
    }
`;

export const PLAYER_SHIELD_TAGS_QUERY = gql`
    query PlayerShieldTagsQuery {
        playerTags {
            id
            tagTier {
                tag
                tier
                tagName
                shieldValue
                subtitle
                unitName
            }
            createdAt
            updatedAt
            imageUrl
        }
    }
`;

export const OTHER_PLAYER_SHIELD_TAGS_QUERY = gql`
    query OtherPlayerShieldTagsQuery($playerId: UUID!) {
        otherPlayerTags(playerId: $playerId) {
            id
            tagTier {
                tag
                tier
                tagName
                shieldValue
                subtitle
                unitName
            }
            createdAt
            updatedAt
            imageUrl
        }
    }
`;

export const PLAYER_TWO_TAGS_QUERY = gql`
    query PlayerTwoTagsQuery {
        playerTwoTags {
            id
            tagTier {
                tag
                tier
                tagName
                shieldValue
                subtitle
                unitName
            }
            createdAt
            updatedAt
            imageUrl
        }
    }
`;

export const OTHER_PLAYER_TWO_TAGS_QUERY = gql`
    query OtherPlayerTwoTagsQuery($playerId: UUID!) {
        otherPlayerTwoTags(playerId: $playerId) {
            id
            tagTier {
                tag
                tier
                tagName
                shieldValue
                subtitle
                unitName
            }
            createdAt
            updatedAt
            imageUrl
        }
    }
`;

export const ALL_SHIELD_TAGS_QUERY = gql`
    query AllShieldTagsQuery {
        allTags {
            name
            slug
            milestones
            maxTiers
            shieldValues
            imageTemplate
            subtitle
            unitName
        }
    }
`;

export const OTHER_ALL_SHIELD_TAGS_QUERY = gql`
    query OtherAllShieldTagsQuery($playerId: UUID!) {
        otherAllTags(playerId: $playerId) {
            name
            slug
            milestones
            maxTiers
            shieldValues
            imageTemplate
            subtitle
            unitName
        }
    }
`;

export const ALL_SHIELD_TWO_TAGS_QUERY = gql`
    query AllShieldTwoTagsQuery {
        allTwoTags {
            name
            slug
            milestones
            maxTiers
            shieldValues
            imageTemplate
            subtitle
            unitName
        }
    }
`;

export const OTHER_ALL_SHIELD_TWO_TAGS_QUERY = gql`
    query OtherAllShieldTwoTagsQuery($playerId: UUID!) {
        otherAllTwoTags(playerId: $playerId) {
            name
            slug
            milestones
            maxTiers
            shieldValues
            imageTemplate
            subtitle
            unitName
        }
    }
`;

export const OTHER_PLAYER_QUERY = gql`
    query OtherPlayerQuery($playerId: UUID!) {
        otherPlayer(playerId: $playerId) {
            id
            name
            vip
            twitchId
            tagOfVanderwood
            goldenWohToken
            permanentVip
            nickname
            moderator
            enabled
            isGota
            gotaSubTimeInDays
            overallSubTimeInDays
            avatarUrl
            clan {
                id
                name
                tag
                twitchEmojiName
                color {
                    hex
                }
                borderColor {
                    hex
                }
                rankNumberColor {
                    hex
                }
                rankColor {
                    hex
                }
            }
            shield {
                id
                shieldNumber {
                    number
                }
                imageUrl
                imageWithTagsUrl
                createdAt
                updatedAt
            }
            shieldTwo {
                id
                shieldNumber {
                    number
                }
                imageUrl
                imageWithTagsUrl
                createdAt
                updatedAt
            }
            bux {
                balance
            }
        }
    }
`;

export const PLAYER_RUNESTONE_CABINET_QUERY = gql`
    query PlayerRunestoneCabinetQuery {
        playerRunestoneCabinet {
            hasRedeemed
            redemptionCount
            ravenguardPoints
            cooldownExpiresAt
            cooldownRemainingSeconds
            streamerUrl
            streamTeamMember {
                id
                twitchUsername
                isAcademy
                player {
                    id
                    name
                }
            }
            runestone {
                id
                runeName
                imageUrl
            }
        }
    }
`;

export const OTHER_PLAYER_RUNESTONE_CABINET_QUERY = gql`
    query OtherPlayerRunestoneCabinetQuery($playerId: UUID!) {
        otherPlayerRunestoneCabinet(playerId: $playerId) {
            hasRedeemed
            redemptionCount
            ravenguardPoints
            cooldownExpiresAt
            cooldownRemainingSeconds
            streamerUrl
            streamTeamMember {
                id
                twitchUsername
                player {
                    id
                    name
                }
            }
            runestone {
                id
                runeName
                imageUrl
            }
        }
    }
`;

export const FREE_RUNESTONE_CLAIMS_QUERY = gql`
    query FreeRunestoneClaimsQuery {
        playerStats {
            availableFreeRunestoneClaims
        }
        featureFlags {
            freeRunestoneClaimsEnabled
        }
    }
`;
